export default "<p>post-guide works!</p>\n"